import { ExpertiseAttachmentResponse } from './model';

export interface DetailsExpertiseAttachmentState {
  readonly expertiseAttachments: ExpertiseAttachmentResponse[];
  readonly selectedAttachmentAmazonId: string;
}

export const enum DetailsExpertiseAttachmentActionTypes {
  FETCH_EXPERTISE_ATTACHMENTS = '@@detailsExpertiseAttachments/FETCH_EXPERTISE_ATTACHMENTS',
  FETCH_EXPERTISE_ATTACHMENTS_FAIL = '@@detailsExpertiseAttachments/FETCH_EXPERTISE_ATTACHMENTS_FAIL',
  FETCH_EXPERTISE_ATTACHMENTS_SUCCESS = '@@detailsExpertiseAttachments/FETCH_EXPERTISE_ATTACHMENTS_SUCCESS',
  RESET_STATE = '@@detailsExpertiseAttachments/RESET_STATE',
  SET_PREVIEW_AMAZON_ID = '@@detailsExpertiseAttachments/SET_PREVIEW_AMAZON_ID'
}
